import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexMarkers,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ChartComponent
} from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';
import { TagsService } from 'src/app/services/tags.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  title: ApexTitleSubtitle;
  markers: ApexMarkers,
  colors: string[]
  stroke: ApexStroke
  fill: ApexFill
  plotOptions: ApexPlotOptions,
  tooltip: ApexTooltip,
  responsive: ApexResponsive[]
};

@Component({
  selector: 'app-chart',
  templateUrl: './radar-chart.component.html',
  styleUrls: ['./radar-chart.component.scss']
})
export class RadarChartComponent implements OnInit, OnChanges {

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  @Input() series;
  labels =  [];

  clickEventSubscription: Subscription;

  constructor(private languageService: LanguageService,
              private tagsService: TagsService
  ) {
    this.chartOptions = {
      series: [
        {
          name: 'Impact',
          data: [100, 60, 100, 60, 80, 100, 80]
        }
      ],
      colors: ['#34D1B0'],
      markers: {
        size: 5,
        colors: ['#34D1B0'],
        hover: {
          size: 10
        }
      },
      stroke: {
        show: false
      },
      fill: {
        opacity: 0.5,
        colors: ['#ABEBDD'],
      },
      chart: {
        toolbar: {
          show: false
        },
        height: 370,
        width: '100%',
        type: 'radar',
        background: '#E8FFFA',
        parentHeightOffset: 0,
        redrawOnParentResize: true
      },
      title: {
        text: 'My First Angular Chart'
      },
      xaxis: {
        labels: {
          show: true,
          style: {
            colors: ['#2D6675', '#2D6675', '#2D6675', '#2D6675', '#2D6675', '#2D6675', '#2D6675', '#2D6675'],
            fontFamily: '"Alegreya Sans", sans-serif',
            fontSize: '16px',
            fontWeight: 'normal'
          }
        }
      },
      yaxis: {
        min: 0,
        max: 100,
        show: false,
        tickAmount: 5
      },
      plotOptions: {
        radar: {
          polygons: {
            fill: {
              colors: ['#E8FFFA']
            }
          }
        }
      },
      tooltip: {
        enabled: true,
        custom: ({series, seriesIndex, dataPointIndex, w}) => {
          return '<div class="custom-chart-tooltip">' +
                    `<img alt="north-star" src="/assets/icons/north_star/${w.globals.labels[dataPointIndex].toLowerCase().replace(' ', '_')}-chart.svg">` +
                    '<div>' + w.globals.labels[dataPointIndex] + ': ' + (series[seriesIndex][dataPointIndex]).toFixed(2) + '%' + '</div>' +
            '</div>';
        }
      },
      responsive: [{
        breakpoint: 500,
        options: {
          chart: {
            height: 350,
          },
          xaxis: {
            labels: {
              style: {
                fontSize: '14px'
              }
            }
          }
        },
      }]
    };

    this.clickEventSubscription = this.tagsService.getClickEventImpact().subscribe(() => {
      this.changeLabels();
    });
  }

  ngOnInit(): void {
    this.changeLabels();

    this.chartOptions.yaxis = {
      min: 0,
      max: Math.max(...this.series[0].data),
      show: false,
      tickAmount: 5
    };
  }

  ngOnChanges() {
    this.chartOptions.yaxis = {
      min: 0,
      max: Math.max(...this.series[0].data),
      show: false,
      tickAmount: 5
    };
  }

  changeLabels() {
    switch (this.languageService.getUserUsedLanguage()) {
      case 'en':
         this.labels =  [ 'Carbon offset', 'Reforestation', 'Education', 'Biodiversity', 'Health', 'Zero Waste', 'Inclusiveness', 'Diverse Actions' ];
         break;
      case 'es':
         this.labels =  [ 'Compensación de carbono', 'Reforestación', 'Educación', 'Biodiversidad', 'Salud', 'Cero residuos', 'Inclusión', 'Acciones diversas' ];
         break;
      case 'fr':
         this.labels =  [ 'Compensation carbone', 'Reforestation', 'Education', 'Biodiversité', 'Santé', 'Zéro déchet', 'Inclusion', 'Actions diverses' ];
         break;
    }
  }
}
